import { FEATURE_FLAGS } from '../../../featureFlags';
import TramitesList from './TramitesList.vue';
import TramiteDetails from './TramiteDetails.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.TRAMITES,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: 'tramites',
    name: 'tramites_list',
    component: TramitesList,
    meta: commonMeta,
  },
  {
    path: 'tramites/:tramiteId(\\d+)',
    name: 'tramite_details',
    component: TramiteDetails,
    meta: commonMeta,
    props: route => ({ tramiteId: route.params.tramiteId }),
  },
];

export default routes;
